var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-doc-file-format-symbol';
                    var viewUrl = 'gfx/sprite.svg#view-icon-doc-file-format-symbol';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 550.801 550.801',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };